import { render, staticRenderFns } from "./v2Dashboard.vue?vue&type=template&id=5dbe8120&"
import script from "./v2Dashboard.vue?vue&type=script&lang=js&"
export * from "./v2Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./v2Dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports